import { apiRequest } from '../../api/client';

export type StaffStatus = 'Active' | 'Disabled';

/** Tên vai trò trong enum của backend, khác chuỗi trên dây của JWT (`super_admin`...). */
export type StaffRoleEnum = 'SuperAdmin' | 'BranchManager' | 'Cashier' | 'Host';

export const ROLE_LABELS: Record<StaffRoleEnum, string> = {
  SuperAdmin: 'Quản trị hệ thống',
  BranchManager: 'Quản lý chi nhánh',
  Cashier: 'Thu ngân',
  Host: 'Lễ tân',
};

export interface StaffUser {
  id: string;
  username: string;
  name: string;
  phone: string | null;
  role: StaffRoleEnum;
  branchId: string | null;
  branchName: string | null;
  status: StaffStatus;
  mustChangePassword: boolean;
  lastLoginAt: string | null;
}

/**
 * Mật khẩu tạm **chỉ trả về đúng lần này**. Không có API nào đọc lại được —
 * người quản lý phải đọc ngay cho nhân viên, quên là phải đặt lại mật khẩu.
 */
export interface CreateStaffResult {
  staff: StaffUser;
  temporaryPassword: string;
}

const unwrap = async <T>(promise: Promise<{ data: T }>): Promise<T> => (await promise).data;

export const staffApi = {
  list: () => unwrap(apiRequest<StaffUser[]>('/admin/staff')),

  create: (body: {
    username: string;
    name: string;
    phone?: string | null;
    role: StaffRoleEnum;
    branchId?: string | null;
  }) => unwrap(apiRequest<CreateStaffResult>('/admin/staff', { method: 'POST', body })),

  update: (id: string, body: { name: string; phone?: string | null; status: StaffStatus }) =>
    unwrap(apiRequest<StaffUser>(`/admin/staff/${id}`, { method: 'PUT', body })),

  resetPassword: (id: string) =>
    unwrap(apiRequest<CreateStaffResult>(`/admin/staff/${id}/reset-password`, { method: 'POST' })),
};

export const staffKeys = { all: ['staff'] as const };
